// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import AnamnesisController from "./anamnesis_controller.js"
application.register("anamnesis", AnamnesisController)

import HomeController from "./home_controller.js"
application.register("home", HomeController)

import ResultController from "./result_controller.js"
application.register("result", ResultController)

import LoginController from "./login_controller.js"
application.register("login", LoginController)

import DiagnosticController from "./diagnostic_controller.js"
application.register("diagnostic", DiagnosticController)

import ExaminationsInputController from "./examinations_input_controller.js"
application.register("examinations-input", ExaminationsInputController)

import ExaminationsStepInputController from "./examinations_step_input_controller.js"
application.register("examinations-step-input", ExaminationsStepInputController)

import GameSessionOverviewController from "./game_session_overview_controller.js"
application.register("game-session-overview", GameSessionOverviewController)

import GameSessionController from "./game_session_controller.js"
application.register("game-session", GameSessionController)

import HelloController from "./hello_controller.js"
application.register("hello", HelloController)

import LabResultInputController from "./lab_result_input_controller.js"
application.register("lab-result-input", LabResultInputController)

import LabResultsInputController from "./lab_results_input_controller.js"
application.register("lab-results-input", LabResultsInputController)

import TherapyController from "./therapy_controller.js"
application.register("therapy", TherapyController)

import EditController from "./edit_controller"
application.register("edit", EditController)

import TherapyOptionInputController from "./therapy_option_input_controller.js"
application.register("therapy-option-input", TherapyOptionInputController)

import TherapyStepsInputController from "./therapy_steps_input_controller.js"
application.register("therapy-steps-input", TherapyStepsInputController)

import TherapyOptionsInputController from "./therapy_options_input_controller.js"
application.register("therapy-options-input", TherapyOptionsInputController)


